import { defineStore } from 'pinia';
export const useNewpageData = defineStore('newpagedata', {
    state: () => ({
        gid: '',
        tokenblen: true,
        fullscreen: false,
        GameSrc: "",
        ErrorSet: new Set<any>(),
        vconsoleActivated: false,
    }),
    getters: {},
    actions: {
        setgid(num: any) {
            this.gid = num
        },
        Settokenblen(blen: any) {
            this.tokenblen = blen
        },
        Setfullscreen(data: any) {
            this.fullscreen = data
        },
        Setgamesrc(data: any) {
            this.GameSrc = data
        },
        SetNowtime(data: any) {
        },
        GetLocSetError() {
            const now = new Date();
            const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            const startOfDayTimestamp: any = startOfDay.getTime();
            console.log(startOfDayTimestamp, '输出当天时间戳');
            console.log('开始获取本地 错误数据', localStorage.getItem('erarr'));
            if (localStorage.getItem('erarr')) {
                let inputString = localStorage.getItem('erarr')!
                // / 分离时间戳和数组部分
                let [timestampStr, arrayStr] = inputString.split('——', 2);
                // // 解析数组部分
                let arrayset = JSON.parse(arrayStr);
                console.log(timestampStr);
                console.log(arrayset);
                let numtime = Number(timestampStr)
                if (numtime == startOfDayTimestamp) {
                    console.log('时间戳一致,进行转化', numtime, startOfDayTimestamp);
                    this.ErrorSet = new Set([...arrayset])
                } else {
                    console.log('时间戳不一致,进行删除', numtime, startOfDayTimestamp);
                    localStorage.removeItem('erarr')
                }
            }
        },
        setVConsoleActivated(data: any) {
            this.vconsoleActivated = data
        }

    },

});
